import { baseClient, authClient, getServiceURL } from '@/utils'

const fetchSupportSubjects = ({ catalogId, lang, roles }) => {
	return baseClient.get(`${getServiceURL('support')}/v1/support-types`, {
		params: {
			catalogId,
			lang,
			roleIds: roles ? roles.join(',') : null
		}
	})
}

const sendRequestBudgetUsa = ({ siteLocation, catalogId, lang, project, changeProjectName }) => {

	const url = `${getServiceURL('support')}/v1/support-request/project-budget-usa`

	return authClient.post(url,
		{
			siteLocation,
			catalogId,
			lang,
			project,
			changeProjectName,
		}
	)
}

export default {
	fetchSupportSubjects,
	sendRequestBudgetUsa
}
